import React from 'react'
import { FormattedMessage } from 'react-intl'
import { Box } from '@material-ui/core'

import { useStyles } from './ShowPageTabs_style'
import RouteMapLink from 'wrappers/RouteMapLink/RouteMapLink'
import { GetURL } from 'components/ShowPageTabs/ShowPageTabsHelper'

const ShowPageTabs = (props) => {
    const classes = useStyles()
    const { tabs, selectedTab, setTab } = props

    return (
        <Box className={classes.companyBodyTabsContainer}>
            <Box className={classes.companyBodyTabs}>
                {tabs.map(tab => {
                    const isSelected = tab.value === selectedTab

                    if (tab.value !== 'overview' && tab.count === 0) return null
                    return (
                        <RouteMapLink
                            key={tab.value}
                            className={classes.quickFilterOption}
                            redirectionUrl={GetURL(tab.value, tabs)}
                            onClick={() => setTab(tab.value)}
                        >
                            <Box
                                className={`
                                ${classes.tab}
                                ${isSelected ? classes.selectedTab : ''}
                                ${tab.count ? classes.countTab : ''}
                            `}
                                key={tab}
                            >
                                <FormattedMessage id={`company_tabs.tab.${tab.value}`} />
                                {tab.count &&
                                <span
                                    className={`
                                        ${classes.itemCount}
                                        ${isSelected ? classes.selectedItemCount : ''}
                                    `}
                                >
                                    {tab.count}
                                </span>
                                }
                            </Box>
                        </RouteMapLink>
                    )
                })}
            </Box>
        </Box>
    )
}

export default ShowPageTabs
